module.exports = __webpack_public_path__ + "static/media/night-weather.61d5872e.gif";